import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";

import { routeConfig, RouteConfig } from './routeConfig';

interface RouteProps {
  element: React.ReactNode;
  path?: string;
  index?: boolean;
}

function renderRoute(routeConfig: RouteConfig) {
  const { routes: childRoutes, path, Component } = routeConfig;
  let routeProps: RouteProps = {
    element: <Component />
  };
  if (path) {
    routeProps.path = path;
  } else {
    routeProps.index = true;
  }
  if (!childRoutes || childRoutes.length === 0) {
    return <Route {...routeProps} key={routeProps.path} />
  }
  return (
    <Route {...routeProps} key={routeProps.path}>
      {childRoutes.map((routeConfig: RouteConfig) => renderRoute(routeConfig))}
    </Route>
  );
}

export default function Router() {
  return (
    <BrowserRouter>
      <Routes>
        {routeConfig.map(config => renderRoute(config))}
      </Routes>
    </BrowserRouter>
  );
}
